export function MethodPost(url,data){
  return new Promise((resolve,reject)=>{
    this.axios({
      data,
      url,
      method:'post'
    }).then(res=>{
      resolve(res)
    },err=>{
      resolve(err)
    }).catch(err=>{
      reject(err)
    })
  })
}